"use client";

import { Button } from "../ui/button";
import { useTranslations } from "next-intl";
import { useCookieConsent } from "./CookieConsentContext";
const CookieConsent = () => {
  const { hasConsent, isInitialized, updateConsent } = useCookieConsent();
  const t = useTranslations();

  const handleAccept = () => {
    updateConsent(true);
  };

  const handleDecline = () => {
    updateConsent(false);
  };

  if (!isInitialized || hasConsent !== null) return null;

  return (
    <div className="fixed bottom-0 left-0 right-0 z-50 bg-white border-t border-gray-200 shadow-lg p-4">
      <div className="container mx-auto max-w-7xl">
        <div className="flex flex-col md:flex-row md:items-center justify-between gap-4">
          <div className="flex-1">
            <h3 className="text-lg font-medium">
              {t("cookies.title")}
            </h3>
            <p className="text-sm text-gray-600 mt-1">
              {t("cookies.description")}
            </p>
          </div>
          <div className="flex gap-3 mt-3 md:mt-0">
            <Button type="button" variant="outline" onClick={handleDecline}>
              {t("cookies.decline")}
            </Button>
            <Button type="button" onClick={handleAccept}>
              {t("cookies.accept")}
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CookieConsent;
